import { useCinematicStore } from '../../store/cinematicSlice';
import { DialogueScreen } from './DialogueScreen';
import { ItemShowcaseScreen } from './ItemShowcaseScreen';

export const CinematicOverlay = () => {
  const dialogue = useCinematicStore((s) => s.dialogue);
  const showcase = useCinematicStore((s) => s.showcase);
  return (
    <>
      {dialogue && <DialogueScreen />}
      {showcase && <ItemShowcaseScreen />}
    </>
  );
};
